import { render, staticRenderFns } from "./SubAccounts.vue?vue&type=template&id=811d767c&scoped=true"
import script from "./SubAccounts.vue?vue&type=script&lang=js"
export * from "./SubAccounts.vue?vue&type=script&lang=js"
import style0 from "./SubAccounts.vue?vue&type=style&index=0&id=811d767c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811d767c",
  null
  
)

export default component.exports